import alignerIssuesConstants from '@constants/alignerIssues.constants'

export default [
  {
    name: alignerIssuesConstants.MISSING_ALIGNER,
    value: 'Missing aligner',
  },
  {
    name: alignerIssuesConstants.BROKEN_ALIGNER,
    value: 'Broken aligner',
  },
  {
    name: alignerIssuesConstants.IRRIGATION_TO_GUM,
    value: 'Irritation to gum',
  },
  {
    name: alignerIssuesConstants.SHARP_EDGES,
    value: 'Sharp edges',
  },
]
